import {TFunction} from "i18next";

export const getRefServiceStatusFacetDisplayValue = (
  facet: string,
  t: TFunction<"common"[], undefined, "common"[]>
): string => {
  const props = getIntlProps(facet);
  return t(props.key, props.defaultValue)
};

const getIntlProps = (facet: string): { key: string, defaultValue: string } => {
  switch (facet) {
    case "CLEARANCE":
      return {
        key: "common.entity.refservicestatusfacet.clearance",
        defaultValue: "Clearance"
      }
    case "TREATMENT":
      return {
        key: "common.entity.refservicestatusfacet.treatment",
        defaultValue: "Treatment"
      }
    case "ACCESS":
      return {
        key: "common.entity.refservicestatusfacet.access",
        defaultValue: "Access"
      }
    case "INSPECTION":
      return {
        key: "common.entity.refservicestatusfacet.inspection",
        defaultValue: "Inspection"
      }
    default:
      return {
        key: "common.entity.refservicestatusfacet.unknown",
        defaultValue: "Unknown"
      }
  }
};
